import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class HelperService {

  constructor() { }
}

export function getSearchUrl(baseUrl: string, params: any): string {
  // Build search params only if value exists
  return baseUrl.concat(
    Object.entries(params).map(([key, val]) => {
      if (val) {
        return `${key}=${val}`
      }
      return
    }).filter(Boolean).join('&')
  );
}
